import blue_matrix_1080p from "../assets/blue_matrix_1080p.webm";
import blue_matrix_720p from "../assets/blue_matrix_720p.webm";
import blue_matrix_poster from "../assets/blue_matrix_poster.jpg";
import { useState, useEffect } from "react";
import Generate from "./Generate.jsx";
import {
    Card,
    Space,
    Typography,
    Button,
    Select,
    Slider,
    Checkbox,
    Row,
    Col,
    message,
} from "antd";
import {
    ReloadOutlined,
    CopyOutlined,
    CheckCircleFilled,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const Home = () => {
    const [passwordType, setPasswordType] = useState("Password");
    const [sliderValue, setSliderValue] = useState(8);
    const [isNumbers, setIsNumbers] = useState(false);
    const [isSymbols, setIsSymbols] = useState(false);
    const [password, setPassword] = useState("");
    const [isCopied, setIsCopied] = useState(false);
    const [shouldLoadVideo, setShouldLoadVideo] = useState(true);

    useEffect(() => {
        setPassword(Generate(passwordType, isNumbers, isSymbols, sliderValue));
    }, [passwordType, isNumbers, isSymbols, sliderValue]);

    useEffect(() => {
        const shouldLoad = !(
            navigator.connection?.effectiveType === '2g' ||
            navigator.connection?.saveData
        );
        setShouldLoadVideo(shouldLoad);
    }, []);

    const handleCopy = () => {
        navigator.clipboard.writeText(password);
        setIsCopied(true);
        message.success("Password copied to clipboard!");
        setTimeout(() => setIsCopied(false), 2000);
    };

    const handleRefresh = () => {
        setPassword(Generate(passwordType, isNumbers, isSymbols, sliderValue));
    };

    const handleTypeChange = (value) => {
        setPasswordType(value);
        if (value === "Password") {
            setSliderValue(8);
        } else {
            setSliderValue(3);
        }
    };

    const videoSrc = shouldLoadVideo && window.innerWidth < 768
        ? blue_matrix_720p
        : blue_matrix_1080p;

    return (
        <div className="home">
            {/* Video background */}
            <div className="video_bg">
                <video
                    src={videoSrc}
                    poster={blue_matrix_poster}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                    onLoadedData={() => {
                        document.querySelector('.video_bg video')?.classList.add('loaded');
                    }}
                    onError={() => setShouldLoadVideo(false)}
                ></video>
            </div>

            {/* Password generator area */}
            <div className="password_generator_container">
                <Card className="password_card" bordered={false}>
                    <Space direction="vertical" size="large" style={{ width: "100%" }}>
                        {/* Password Display */}
                        <div className="password_display_container">
                            <Text className="password_text" copyable={false}>
                                {password}
                            </Text>
                            <Space className="password_actions">
                                <Button
                                    type="primary"
                                    icon={<ReloadOutlined />}
                                    onClick={handleRefresh}
                                    className="action_button"
                                >
                                    Refresh
                                </Button>
                                <Button
                                    type="default"
                                    icon={isCopied ? <CheckCircleFilled /> : <CopyOutlined />}
                                    onClick={handleCopy}
                                    className={`action_button ${isCopied ? "copied" : ""}`}
                                >
                                    {isCopied ? "Copied!" : "Copy"}
                                </Button>
                            </Space>
                        </div>

                        {/* Controls */}
                        <div className="controls_container">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} md={12}>
                                    <div className="control_item">
                                        <Text className="control_label">Type</Text>
                                        <Select
                                            value={passwordType}
                                            onChange={handleTypeChange}
                                            style={{ width: "100%" }}
                                            className="type_select"
                                        >
                                            <Select.Option value="Password">Password</Select.Option>
                                            <Select.Option value="PIN">PIN</Select.Option>
                                        </Select>
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="control_item">
                                        <Text className="control_label">
                                            Length: <strong>{sliderValue}</strong>
                                        </Text>
                                        <Slider
                                            min={passwordType === "Password" ? 8 : 3}
                                            max={passwordType === "Password" ? 50 : 12}
                                            value={sliderValue}
                                            onChange={setSliderValue}
                                            className="length_slider"
                                        />
                                    </div>
                                </Col>
                            </Row>

                            {passwordType === "Password" && (
                                <div className="checkbox_container">
                                    <Row gutter={[16, 16]}>
                                        <Col xs={24} sm={12}>
                                            <Checkbox
                                                checked={isNumbers}
                                                onChange={(e) => setIsNumbers(e.target.checked)}
                                                className="custom_checkbox"
                                            >
                                                Include Numbers
                                            </Checkbox>
                                        </Col>
                                        <Col xs={24} sm={12}>
                                            <Checkbox
                                                checked={isSymbols}
                                                onChange={(e) => setIsSymbols(e.target.checked)}
                                                className="custom_checkbox"
                                            >
                                                Include Symbols
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>
                    </Space>
                </Card>
            </div>
        </div>
    );
};

export default Home;
